import { render } from "./WohnungStep5.vue?vue&type=template&id=02541eda"
import script from "./WohnungStep5.vue?vue&type=script&lang=js"
export * from "./WohnungStep5.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__